module.exports = __webpack_public_path__ + "img/icon_04.2817b770.png";